import { Component, Input } from '@angular/core';
import { DocumentsService } from '../../Services/documents.service';
import { SharedDataService } from '../../Services/shared-data/shared-data.service';
import {  PS_Supplier_Archive_Docs_Result, Supplier } from '../../all-models';
import { saveAs } from '@progress/kendo-file-saver';


import {
  GroupDescriptor,
  DataResult,
  process,
} from '@progress/kendo-data-query';

import { SuppliersService } from '../../all-services';
import moment from 'moment';

@Component({
  selector: 'doc-histo-button',
  templateUrl: './doc-histo-button.component.html',
  styleUrls: ['./doc-histo-button.component.scss']
})
export class DocHistoButtonComponent {
  @Input() btnClass?: string = 'btn-xs btn-warning';
  @Input() supplier?: Supplier;

  //supplier?: Supplier;
  public WindowOptions: any = {
    width: 1200,
    height: 500,
    top: undefined,
    left: undefined,
    state: 'maximized',
    visible: false
  }
  constructor(
    public sharedDatasSvc: SharedDataService,
    private docsSvc: DocumentsService,
    private suppliersSvc:SuppliersService) { }
    
    
  
    

  public lstDatas: DataResult;
  lstDocs: PS_Supplier_Archive_Docs_Result[] = [];
  

  reload(completeCallback: () => any = null): void {
    this.sharedDatasSvc.WindowLock();
   this.docsSvc.getArchiveDocList(this.supplier?.Id, this.sharedDatasSvc.lngCod)
    .subscribe(results=>{
        this.lstDocs = results;
        this.lstDocs.forEach(d=>{
          if (d.DateCrea) d.DateCrea =  moment(d.DateCrea).toDate();
          if (d.DateExpi) d.DateExpi =moment(d.DateExpi).toDate();
          if (d.StatutDate) d.StatutDate =moment(d.StatutDate).toDate();
        });
        this.sharedDatasSvc.WindowUnlock();
        if (completeCallback) completeCallback();       
         this.refreshDataGrid();
    });
  }

  public groups: GroupDescriptor[] = [{ field: "DocTypLib" },{ field: "RefDocLib" }];


  get btnIsHidden():boolean {
    if (!this.supplier) return true;
    //return this.supplier?.StatutId!=10;
    return this.sharedDatasSvc.supplierStatuts.some(s=> s.Id == this.supplier?.StatutId && s.Cod<'800');
  }

  refreshDataGrid():void{
    this.lstDatas = process(this.lstDocs, { group: this.groups });
  }

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.refreshDataGrid();
  }

  reloadAndShow():void{
    this.reload(()=>{this.showWindow(true)});
  }
  showWindow(visible: boolean): void {
    this.WindowOptions.visible = visible;
  }

  btnDownloadFileClick(doc:PS_Supplier_Archive_Docs_Result):void {
    this.docsSvc.downloadFile(this.supplier?.Id, doc.Id)
      .subscribe(blob => {
        saveAs(blob, doc.Filename);
      });
  }
}

